import { Search } from "@/src/svg/Search";
import "./style.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface HeaderDeskActivePanelProps {
  absolutActiveTab: string | null;
}

const HeaderDeskActivePanel = ({ absolutActiveTab }: HeaderDeskActivePanelProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (absolutActiveTab === "search" || absolutActiveTab === "menu") {
      document.body.classList.add("body-blur-overlay");
    } else {
      document.body.classList.remove("body-blur-overlay");
    }

    return () => {
      document.body.classList.remove("body-blur-overlay");
    };
  }, [absolutActiveTab]);

  const handleSearch = () => {
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
      document.body.classList.remove("body-blur-overlay");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <>
      <div className={`header-active-panel ${absolutActiveTab === "search" ? "active" : ""}`}>
        <div className="header-active-panel-search container">
          <h1 className="header-active-panel-search-title">Search</h1>
          <div className="header-active-panel-search-input">
            <input
              type="search"
              placeholder="Поиск..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button onClick={handleSearch}>
              <Search /> <span>Найти</span>
            </button>
          </div>
        </div>
      </div>
      <div className={`header-active-panel ${absolutActiveTab === "menu" ? "active" : ""}`}>
        {/* содержимое панели menu */}
      </div>
    </>
  );
};

export default HeaderDeskActivePanel;
